import * as R from 'ramda';
import { createSelector } from 'reselect';

import {
  getItemById,
  getOrgSettings,
  getDataFromState,
  getItemsFromState,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';


const combiner = (contacts, requests, requestSources, requestStatuses, requestLabels, users) =>
  requestSources
    ? Object.keys(contacts).map(key => Object.assign({}, {
      ...contacts[key],
      requests:
          contacts[key].requests.map(requestId =>
            !R.isNil(requests[requestId])
              ? ({
                ...requests[requestId],
                source: requestSources[requests[requestId].source],
                status: requestStatuses[requests[requestId].status],
                labels: requests[requestId].labels.map(id => requestLabels[id]),
                responsibleUser: users[requests[requestId].responsibleUser] || {},
              })
              : null).filter(request => request)
          || [],
    }))
    : [];

export const getContactsWithRequests = createSelector(
  [
    getDataFromState('contacts'),
    getItemsFromState('requests'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
    getUsers,
  ],
  combiner,
);

export const getSpecificContactsWithRequests = createSelector(
  [
    getDataFromStateAndProps('contacts'),
    getItemsFromState('requests'),
    getOrgSettings('requestSources'),
    getOrgSettings('requestStatuses'),
    getOrgSettings('requestLabels'),
    getUsers,
  ],
  combiner,
);

export const getContactById = createSelector(
  getItemById('contacts', 'contactId'),
  contact => contact || {},
);


export const getThreadsByContactId = (state, { contactId }) =>
  state.contacts.threads[contactId] || [];

export const getContactThreadById = (state, { contactId, threadId }) =>
  R.head(R.filter(
    R.propEq('_id', threadId),
    state.contacts.threads[contactId],
  )) || {};


export const getContacts = ({ contacts }) => contacts;

export const getOpenContact = R.compose(
  R.pick(['openContactCard']),
  getContacts,
);

export const getOpenContactThread = R.compose(
  thread => R.head(R.values(thread)),
  R.pick(['openContactThread']),
  getContacts,
);

export const getOpenContactThreadPage = (threadId, state) =>
  R.compose(
    R.pathOr(1, ['threadPages', threadId]),
    getContacts,
  )(state);


export const getContactThreads = createSelector(
  [getThreadsByContactId],
  threads => threads,
);

export const getContactThreadMessages = createSelector(
  [getContactThreadById],
  thread => R.propOr([], 'messages')(thread),
);

export const getContactThreadMessagesCount = createSelector(
  [getContactThreadById],
  thread => R.propOr(0, 'messagesCount')(thread),
);

export const getContactThreadsPage = R.compose(
  R.prop('currentThreadsPage'),
  getContacts,
);

export const getContactThreadsTotalCount = R.compose(
  R.prop('totalThreadsCount'),
  getContacts,
);



// WEBPACK FOOTER //
// ./src/redux/selectors/contacts.js